import script from "./SubscriptionPrice.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionPrice.vue?vue&type=script&lang=js"
export * from "./SubscriptionPrice.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/subscription-card/SubscriptionPrice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4d50c60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4d50c60', __exports__)) {
    api.reload('e4d50c60', __exports__)
  }
  
}


export default __exports__